"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var finn_1 = require("./finn");
var FinnRec = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#4F46E5' : _a, width = props.width, height = props.height, children = props.children, rest = __rest(props, ["fill", "width", "height", "children"]);
    var radius = 0;
    if (typeof width === 'number') {
        radius = width / 2;
    }
    else if (typeof height === 'number') {
        radius = height / 2;
    }
    return (react_1.default.createElement(adaptive_1.default, __assign({ small: finn_1.FinnSmall, fill: fill, shift: -20, cutoffRadius: 33, minRadius: 20, innerScale: 0.8, width: width, height: height }, rest), radius > 54 ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tspan", { fontSize: "12", fontWeight: "700" }, "Anbefalinger"),
        react_1.default.createElement("tspan", { x: "0", dy: "22" }, children))) : (react_1.default.createElement("tspan", { fontSize: "12", fontWeight: "700" }, "Anbef."))));
};
exports.default = FinnRec;
